import { FilterKeyType } from "@/services/cloudchipr.api";

export const commonExcludedFilters: FilterKeyType[] = [
  "resource_unique_identifier",
];
